import {
  CalendarCheck,
  CalendarClock,
  CheckCircle,
  Eye,
  Info,
  MailPlus,
  Sliders,
  UserPlus,
} from "@tamagui/lucide-icons";
import type { LearnAboutInfo } from "../LearnScreen";

export const DateDueLearnMore: LearnAboutInfo[] = [
  {
    titleIcon: CalendarClock,
    title: "Reminders",
    subtitle: "Get notified about important dates",
    image: require("../../../../web_legacy/static/reminder_card_preview.webp"),
    featureList: [
      {
        icon: CalendarCheck,
        text: "1. Enter a date and describe the event that happens",
      },
      {
        icon: MailPlus,
        text: "2. Register your email to get reminders sent out when it's three months, one month and one week left",
      },
      {
        icon: UserPlus,
        text: "3. (Optional) Set one of more users as owner for the reminder",
      },
      {
        icon: CheckCircle,
        text: "4. Once the action is done, you can set it as finished",
      },
      {
        icon: Eye,
        text: "5. See the days left and status in the overview",
      },
    ],
    descriptions: [
      {
        icon: Info,
        title: "What is it?",
        description:
          "Never miss an important date, sending timely email alerts to every member when it matters most.",
      },

      {
        icon: Sliders,
        title: "Extra options",
        description:
          "If more than one needs to do what the reminder describes, you can assign those user and see who has finished it or not.",
      },
    ],
  },
];
